module.exports = __webpack_public_path__ + "img/ps-pro.4fdba8ff.png";